import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

import ServiceFormCalendarAvailability from 'app/calendarV4/services/serviceForm/ServiceFormCalendarAvailability';
import ActionButton from 'common/components/ActionButton';
import CalendarType from 'common/enums/calendarTypes';
import useFlexBoxStyles from 'common/flexBox';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getServicesSavePending } from 'redux/slices/iCalendarV4';
import { closeNestedDialogAction, openNestedDialog } from 'redux/slices/nestedDialogSlice';
import ServiceCalendarsRender from './ServiceCalendarsRender';
import ServiceFormSelectCalendars from './ServiceFormSelectCalendars';

// const sortUnits = (array) => {
//     return array.sort((a, b) => {
//         const nameA = a.name || a.productName;
//         const nameB = b.name || b.productName;
//         const primaryComparison = nameA?.localeCompare(nameB);
//         if (primaryComparison === 0) {
//             const externalIdA = a.externalId || '';
//             const externalIdB = b.externalId || '';
//             return externalIdA?.localeCompare(externalIdB);
//         }
//         return primaryComparison;
//     });
// };

const ServiceFormCalendars = (props) => {
    const { selectedCalendars, setSelectedCalendars, groupId, handleSubmit, cancel, setSubForm } = props;
    const { classes: flexBox, cx } = useFlexBoxStyles();
    const savePending = useSelector(getServicesSavePending);
    const dispatch = useDispatch();
    const [expand, setExpand] = useState(false);

    const { t } = useTranslation();

    const deleteCalendar = (calendar) => {
        const index = selectedCalendars.findIndex((b) => b.id === calendar.id);
        const calendarsTemp = [...selectedCalendars.slice(0, index), ...selectedCalendars.slice(index + 1)];
        setSelectedCalendars(calendarsTemp);
    };

    const editAvailability = (availability, calendar) => {
        const index = selectedCalendars.findIndex((b) => b.id === calendar.id);
        const selectedTemp = [
            ...selectedCalendars.slice(0, index),
            { ...calendar, ...(availability ? { availability } : {}) },
            ...selectedCalendars.slice(index + 1),
        ];
        setSelectedCalendars(selectedTemp);
        dispatch(closeNestedDialogAction());
    };

    const editCalendar = (calendar) => {
        setExpand(calendar.type);
        dispatch(
            openNestedDialog(
                <ServiceFormCalendarAvailability
                    calendar={calendar}
                    handleSubmit={(a) => editAvailability(a, calendar)}
                />,
            ),
        );
    };

    const selectCalendar = (type) => {
        setSubForm(
            <ServiceFormSelectCalendars
                type={type}
                calendars={[]}
                selectedCalendars={selectedCalendars.filter((calendar) => calendar.type === type)}
                close={() => setSubForm(null)}
                onConfirm={(calendars) => {
                    const calendarsTemp = selectedCalendars.filter((calendar) => calendar.type !== type);
                    setSelectedCalendars([...calendarsTemp, ...calendars]);
                }}
                emptyType={''}
                sectionName={type === CalendarType.AGENT ? t('user.userStatistics.agents') : t('service.form.assets')}
                userGroupId={groupId}
            />,
        );
    };

    const activeCalendar = (calendar) => {
        const idx = selectedCalendars.findIndex((b) => b.id === calendar.id);
        const newCalendar = {
            ...calendar,
            active: !calendar.active,
        };
        setSelectedCalendars([...selectedCalendars.slice(0, idx), newCalendar, ...selectedCalendars.slice(idx + 1)]);
    };

    return (
        <Stack className={cx(flexBox.flex, flexBox.gap2, flexBox.column, flexBox.overflowHidden, flexBox.h100)}>
            <Stack direction="column" className={cx(flexBox.overflowXHidden, flexBox.scrollbarNone, flexBox.h100)}>
                <Stack
                    direction="column"
                    spacing={1}
                    className={cx(flexBox.overflowXHidden, flexBox.scrollbarNone, flexBox.h100)}
                >
                    <ServiceCalendarsRender
                        expanded={
                            selectedCalendars?.filter((calendar) => calendar.type === CalendarType.AGENT).length > 0 ||
                            expand === CalendarType.AGENT
                        }
                        sectionTitle={t('user.userStatistics.agents')}
                        calendars={selectedCalendars?.filter((calendar) => calendar.type === CalendarType.AGENT)}
                        deleteCalendar={deleteCalendar}
                        selectCalendar={() => selectCalendar(CalendarType.AGENT)}
                        addButtonText={t('calendar.common.add')}
                        editButton={true}
                        editCalendar={(calendar) => editCalendar(calendar)}
                        activeCalendar={activeCalendar}
                        carousel={false}
                    />

                    <ServiceCalendarsRender
                        expanded={
                            selectedCalendars?.filter((calendar) => calendar.type === CalendarType.ASSET).length > 0 ||
                            expand === CalendarType.ASSET
                        }
                        sectionTitle={t('service.form.assets')}
                        calendars={selectedCalendars?.filter((calendar) => calendar.type === CalendarType.ASSET)}
                        deleteCalendar={deleteCalendar}
                        selectCalendar={() => selectCalendar(CalendarType.ASSET)}
                        addButtonText={t('calendar.common.add')}
                        editButton={true}
                        editCalendar={(calendar) => editCalendar(calendar)}
                        carousel={false}
                        activeCalendar={activeCalendar}
                    />
                </Stack>
            </Stack>
            <Stack
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
                spacing={1}
                className={flexBox.paddingTop2}
            >
                <ActionButton onClick={cancel} color="default" fitWidth disabled={savePending}>
                    {t('multimedia.multimediaForm.cancel')}
                </ActionButton>

                <ActionButton
                    color="primary"
                    autoFocus
                    fitWidth
                    disabled={savePending}
                    loading={savePending}
                    onClick={handleSubmit}
                >
                    {t('app.common.save')}
                </ActionButton>
            </Stack>
        </Stack>
    );
};

export default ServiceFormCalendars;
